import React = require('react');
import Loading from '../../../../../../../../components/Loading';
import QuoteIcons from '../../../../../Components/Icon/QuoteIcons';

interface IEditSectionButtonProps {
  isCalculating: boolean;
  handleEdit: () => any;
  hidden?: boolean
}

export const EditSectionButton = ({
                                    isCalculating,
                                    handleEdit,
                                    hidden = false
                                  }: IEditSectionButtonProps) => {

  const handleButtonEdit = () => {
    handleEdit()
  }

  if (hidden) {
    return null;
  }

  if (isCalculating) {

    return (
      <>
        <Loading/>
        ... calculating
      </>
    )
  }

  return (
    <div className={'edit'} onClick={handleButtonEdit}>CHANGE <QuoteIcons name={'Edit'} color={'darkBlue'}/></div>
  )
}
